import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSnapshot } from "valtio";
import { registrationStore } from "@/features/auth/store";
import { IdSchema, TIdSchema } from "@/features/auth/forms/schema";
import { fileToBase64 } from "@/utils/conversion";

import SelectInput from "@/components/form-controls/SelectInput";
import TextInput from "@/components/form-controls/TextInput";
import RegisterHeader from "@/features/auth/fragments/registration-header";
import SubmitButton from "@/features/auth/forms/submit-button";
import FileInput from "@/components/form-controls/FileInput";
import AvatarInput from "@/components/form-controls/AvatarInput";


const RegisterIdForm = () => {
    const navigate = useNavigate();
    const store = useSnapshot(registrationStore);
    const { register, handleSubmit, setValue, formState: { errors }} = useForm({
        resolver: yupResolver(IdSchema),
        defaultValues: store.identification ? store.identification: undefined
    })

    const submit = (data: TIdSchema) => {
        store.setIdentification(data);
        navigate("/auth/register/business");
    }

    const onAvatarChange = async(value: FileList) => {
        const base64String = await fileToBase64(value[0]) as string
        setValue("avatarFile", base64String);
    }

    const onFileChange = async (value: FileList) => {
        const base64String = await fileToBase64(value[0]) as string
        setValue("idFile", base64String);
    }

    console.log(errors)

    return (
        <div className="space-y-12">
            <RegisterHeader 
                heading={"Enter Identification Details"}
                description={"Please submit your identification information"}
            />

            <form className="grid grid-cols-2 gap-4" onSubmit={handleSubmit(submit)}>
                <div className="col-span-2">
                    <AvatarInput
                        label="Upload a recent passport-size photo for official use."
                        className=""
                        onChange={onAvatarChange}                 
                    />
                </div>
                
                <SelectInput 
                    label="Nationality"
                    displayName="label"
                    valueName="value"
                    options={[
                        { label: "Tanzania", value: "Tanzania"}
                    ]}
                    error={errors.nationality?.message?.toString()}
                    register={register("nationality")}
                    required
                />

                <TextInput 
                    label="Date of birth"
                    type="date"
                    error={errors.dateOfBirth?.message?.toString()}
                    register={register("dateOfBirth")}
                />

                <SelectInput 
                    label="Identification Type"
                    displayName="label"
                    valueName="value"
                    options={[
                        { label: "NIDA", value: "nida"},
                        { label: "Passport", value: "passport"},
                        { label: "Driving Licence", value: "driving-licence"},
                    ]}
                    error={errors.idType?.message?.toString()}
                    register={register("idType")}
                    required
                />

                <TextInput 
                    label="Identification Number"
                    placeholder="enter indentification number"
                    error={errors.idNumber?.message?.toString()}
                    register={register("idNumber")}
                    required
                />

                <FileInput 
                    label="Upload ID document/Image"
                    placeholder={"Upload a clear copy of your identification document (PDF or image)"} 
                    className="col-span-2"
                    onChange={onFileChange} 
                    formats={""}                
                />

                <SubmitButton 
                    hasPrev={true}
                    onPrev={() => navigate("/auth/register/personal")}
                />
            </form>
        </div>
    )
}

export default RegisterIdForm